import React, { useEffect, useState } from "react";
import { Box, Typography, Paper, Divider, Grid, Checkbox, FormControlLabel, Button, Stepper, Step, StepLabel, Tabs, Tab, } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import ProductInfo from "./ProductInfo";
import { setProductSelectImageModal, setProductassetDashboardProductassetList, setAssetcommentsList, updateProductObj, setProductassetAnnotateAssetModal } from 'store/slice/PharmaSlice';
import SelectImageActionModal from "components/product/action/selectImage/SelectImageActionModal";
import { setSelectedImage, setSelectedAssetIdList } from "store/slice/ImageGallerySlice";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { setProductassetViewModal } from "store/slice/PharmaSlice";
import { attachCommentAPI } from 'api/OmsOrdermgmtWebServices';
import EditIcon from '@mui/icons-material/Edit';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { setCompleteTaskButtonEnabled, setReferbackTaskButtonEnabled, setAnnotationMode } from "store/slice/AppSlice";
import FieldView2 from "core/components/layout/FieldView2";
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import { updateQAinputAPI } from 'api/OmsOrdermgmtWebServices';
import { setCheckRejectCondtion } from 'store/slice/AppSlice';
import CommentMgmt from "./comment/CommentMgmt";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { updateProductInfo } from "components/product/ProductAPI";
import ImageAnotation from "core/components/image-anotation/ImageAnotation";
import AnnotateAssetActionModal from "components/productasset/action/AnnotateAsset/AnnotateAssetActionModal";
import { setAnnotations } from "store/slice/AppSlice";
import { getAssetannotationInfoByAssetidAPI } from "api/AssetannotationAPI";

export default function TaskSpaceQA() {
  const dispatch = useDispatch();

  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { selectedTaskObj } = useSelector((state) => state.appslice.wkflow);
  const { taskApiResponse, taskApiResponseError,taskCompleted } = useSelector((state) => state.appslice.wkflow);
  const [tabIndex, setTabIndex] = useState(0);
  const [enterBatchNumAndExpiryDate, setEnterBatchNumAndExpiryDate] = useState(true);
  const [designBatchExpiryConfirmed, setDesignBatchExpiryConfirmed] = useState(false);
  const {selectedImageId, selectedImage, selectedImagePath} = useSelector((state) => state.imagegalleryslice);

  // Comment state
  const [comment, setComment] = useState();
  const [editOpen, setEditOpen] = useState(false);
  const [editValue, setEditValue] = useState(comment);
  const [showError, setShowError] = useState(false);
  const [commentApiError, setCommentApiError] = useState("");

  // New state for batch/expiry dialog
  const [batchDialogOpen, setBatchDialogOpen] = useState(false);
  const [batchNumber, setBatchNumber] = useState(productObj.batchnumber || "");
  const [expiryDate, setExpiryDate] = useState(productObj.expirydate ? productObj.expirydate.split('T')[0] : "");

  // useEffect(()=>{
  //     let commentObjList = [];
  //     getAssetannotationInfoByAssetidAPI(productObj.assetid, (apiResponse) => {
  //         apiResponse.forEach(annotation => {
  //             let commentObj = {
  //                 id: annotation.id,
  //                 commentId: annotation.annotationid,
  //                 height: annotation.height,
  //                 text: annotation.title,
  //                 type: annotation.annotationtype,
  //                 width: annotation.width,
  //                 x: annotation.xposition,
  //                 y: annotation.yposition
  //             };
  //             commentObjList.push(commentObj);
  //         });
  //         console.log("commentObjList=>"+JSON.stringify(commentObjList));
  //         dispatch(setAnnotations(commentObjList));
         
  //     }, ()=>{})
  // },[productObj.id])

  useEffect(() => {
    dispatch(setSelectedImage({ name: '---', path: '', id: -1 }));

    dispatch(setCheckRejectCondtion(true))
  }, []);
  useEffect(() => {

  }, [taskApiResponse, taskApiResponseError,taskCompleted]);

  useEffect(() => {
    if (isNonTCS()){
      if(designBatchExpiryConfirmed)
        dispatch(setCompleteTaskButtonEnabled(true));
      else
        dispatch(setCompleteTaskButtonEnabled(false));
    }
  },[designBatchExpiryConfirmed]);

  useEffect(() => {
    if (productObj && selectedImageId!==-1) {
      updateProductInfo(productObj.id,
      {
        qaassetid: selectedImageId,
        qaassetname: selectedImage,
        qaassetpath: selectedImagePath
      },
        (response) => {
          dispatch(updateProductObj(response));
        },
        (error) => {
          console.error("Failed to attach asset to product:", error);
        }
    )}
  },[selectedImageId]);

  const handleEditOpen = () => {
    setEditValue(comment);
    setEditOpen(true);
  };
  useEffect(()=>{
    if (enterBatchNumAndExpiryDate && (productObj.expirydate==='' || productObj.batchnumber==='')) 
      dispatch(setCompleteTaskButtonEnabled(false));
  },[enterBatchNumAndExpiryDate])

  useEffect(() => {
    dispatch(setReferbackTaskButtonEnabled(true));

    if (productObj.formname == 'Tablet' || productObj.formname == 'Capsule' || productObj.formname == 'Capsul' || productObj.formname == 'Sachet') {
      setEnterBatchNumAndExpiryDate(false);
      dispatch(setCompleteTaskButtonEnabled(true));
      
    } else {
      
      setEnterBatchNumAndExpiryDate(false);
      // setExpiryDate(productObj.expirydate ? productObj.expirydate.split('T')[0] : "");
      // setBatchNumber(productObj.batchnumber || "");

      // if (productObj.expirydate && productObj.batchnumber) {
      //    dispatch(setCompleteTaskButtonEnabled(true));
        
      // } else {
      //     dispatch(setCompleteTaskButtonEnabled(false));
      // }
    }

    
  }, []);

  const isNonTCS = () => {
    if (productObj.formname == 'Tablet' || productObj.formname == 'Capsule' || productObj.formname == 'Capsul' || productObj.formname == 'Sachet') return false;
    return true;
  }
  const handleEditSave = () => {
    setCommentApiError(""); // Clear previous error
    attachCommentAPI(
      {
        productId: productObj.id,
        assetId: productObj.assetid,
        taskInstanceId: selectedTaskObj.id,
        comment: editValue
      },
      (response) => {
        setComment(response.assetcommentsInfo.title); // update comment after success
        dispatch(setReferbackTaskButtonEnabled(true));
        setEditOpen(false); // close popup after API success
      },
      (error) => {
        setCommentApiError(error); // Show error above Save
        console.error("Failed to save comment:", error);
      }
    );
  };
  const showAsset = () => {
    dispatch(setSelectedImage({ 'name': productObj.assetname, 'path': productObj.assetpath }));
    dispatch(setProductassetViewModal(true));

  }
  const showQAasset = () => {
    dispatch(setSelectedImage({ 'name': productObj.qaassetname, 'path': productObj.qaassetpath }));
    dispatch(setProductassetViewModal(true));

  }

  // Handler for opening batch/expiry dialog
  const handleBatchEditOpen = () => {
    console.log("productObj.expirydate=>" + productObj.expirydate)
    setBatchNumber(productObj.batchnumber || "");
    //setExpiryDate(productObj.expirydate || "");
    setBatchDialogOpen(true);
  };

  // Handler for saving batch/expiry
  const handleBatchEditSave = () => {
    updateQAinputAPI({
      productId: productObj.id,
      batchNumber: batchNumber,
      expiryDate: expiryDate
    },
      (response) => {
        dispatch(updateProductObj(response.productInfo));
        setBatchDialogOpen(false);
      },
      (error) => {
        console.error("Failed to update batch/expiry:", error);
        setShowError(true); // Show error snackbar
        //setBatchDialogOpen(false); // Close dialog on error

      }

    )
    setBatchDialogOpen(false);
  };
  const deLinkQaAsset = () =>{
    updateProductInfo(productObj.id,
      {
        qaassetid: '',
        qaassetname: '',
        qaassetpath: ''
      },
      (response) => {
        dispatch(updateProductObj(response));
      },
      (error) => {
        console.error("Failed to attach asset to product:", error);
      }
    )
  }

  return (
    <Grid container direction="row" sx={{ width: '100%' }}>
      <Grid item lg={12} md={12} sm={12} xs={12} sx={{}}>
        <Grid container sx={{ width: '100%' }}>
          <Grid item lg={4} md={4} sm={4} xs={12} sx={{ pr: 1 }}>
            <Box sx={{ borderRadius: 2, minHeight: '70vh', p: 0 }}>
              <Tabs
                value={tabIndex}
                onChange={(_, v) => setTabIndex(v)}
                variant="fullWidth"
                sx={{ borderBottom: 1, borderColor: 'divider' }}
              >
                <Tab label="Product Info" />
                <Tab label="Comments" />
              </Tabs>
              <Box sx={{}}>
                {tabIndex === 0 && (
                  <ProductInfo maxHeight="70vh" />
                )}
                {tabIndex === 1 && (
                  <Box sx={{}}>
                    <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                      <CommentMgmt maxHeight="65vh" status={1} />
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Grid>
          <Grid item lg={8} md={4} sm={4} xs={4} sx={{ }}>
            <Grid container direction="column" sx={{ width: '100%', }}>
              <Grid item lg={12} sx={{}}>
                <Box sx={{ p: 1, backgroundColor: 'white', borderRadius: 2 }}>
                  <Grid container justifyContent="space-between" sx={{mb:2}}>
                    <Grid item lg={8}>
                      <Typography variant="h5" sx={{ color: 'primary.darker', }}>Design Under Review</Typography>
                      {/* <Typography variant="h6" sx={{ color: 'primary.darker', }}>{productObj.qaassetpath}</Typography> */}
                    </Grid>
                    {!taskCompleted && 
                    <Grid item lg={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                      {/* <EditIcon sx={{cursor:'pointer'}} onClick={() =>{dispatch(setAnnotationMode("EDIT")); dispatch(setProductassetAnnotateAssetModal(true))}} /> */}
                        <Button variant="text" size="small" onClick={() => {dispatch(setAnnotationMode("EDIT")); dispatch(setProductassetAnnotateAssetModal(true))}}>
                          Manage Review comments
                        </Button>
                    </Grid>
                    }
                  </Grid>
                  <ImageAnotation 
                    width={800}
                    height={enterBatchNumAndExpiryDate?300:400}
                    imageUrl={productObj.qaassetpath}
                    mode="READ"
                    />
                </Box>
              </Grid>
              <Grid item lg={12} sx={{ mt: 2 }}>
                {enterBatchNumAndExpiryDate &&
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid cotainer direction="column" sx={{ width: '100%', borderRadius: 2 }}>
                    <Grid item lg={12} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: 'white', p: 1, borderRadius: 2 }}>
                      <Grid container >
                        <Grid item xs={12} lg={6}>
                          <FieldView2 label="Expiry Date" value={expiryDate || "N/A"} />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                          <FieldView2 label="Batch Number" value={productObj.batchnumber || "N/A"} />
                        </Grid>
                        <Grid container alignItems="right" justifyContent="flex-end" xs={12} lg={12}>
                          <Button
                            size="small"
                            onClick={handleBatchEditOpen}
                            sx={{
                              minWidth: 0,
                              //position: 'absolute',
                              right: 8,
                              bottom: 8,
                              background: '#f5f5f5',
                              borderRadius: '50%',
                              p: 1,
                            }}
                            aria-label="Edit Batch/Expiry"
                            disabled={taskApiResponse}
                          >
                            <EditIcon fontSize="small" />
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              }
              </Grid>
              {isNonTCS() && (
               <Grid item lg={12} sx={{ mt: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={designBatchExpiryConfirmed}
                        onChange={e => setDesignBatchExpiryConfirmed(e.target.checked)}
                      />
                    }
                    label="I confirm that Design has correct Batch No. and Expiry date"
                  />
               </Grid>
              )}
            </Grid>
          </Grid>
          
           <Grid item lg={4} md={4} sm={4} xs={4} sx={{}}>
            <Grid container direction="column" sx={{ width: '100%', }}>
              {/* <Grid item lg={12} sx={{}}>
                <ProductAssetListBySelectedProduct label="Design List" />
                <Divider sx={{ my: 1 }} />
              </Grid> */}
              
            </Grid>
          </Grid>

        </Grid>



      </Grid>



      <SelectImageActionModal />

      {/* Edit Comment Dialog */}
      <Dialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth="sm" fullWidth>
        <DialogContent>
          <Typography variant="h6" sx={{ mb: 2 }}>Edit Comment</Typography>
          <textarea
            value={editValue}
            onChange={e => setEditValue(e.target.value)}
            rows={6}
            style={{ width: "100%", padding: 8, borderRadius: 4, border: "1px solid #ccc" }}
            maxLength={1024}
          />
          {commentApiError && (
            <MuiAlert severity="error" sx={{ mt: 2 }}>
              {commentApiError}
            </MuiAlert>
          )}
        </DialogContent>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, p: 2 }}>
          <Button onClick={() => setEditOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleEditSave}>Save</Button>
        </Box>
      </Dialog>

      {/* Batch/Expiry Edit Dialog */}
      <Dialog
        open={batchDialogOpen}
        onClose={() => setBatchDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: { minHeight: 260 }
        }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", pr: 0 }}>
          Edit Batch Number & Expiry Date
          <Button
            onClick={() => setBatchDialogOpen(false)}
            sx={{ minWidth: 0, color: "grey.700" }}
            aria-label="Close"
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <TextField
            label="Batch Number"
            value={batchNumber}
            onChange={e => setBatchNumber(e.target.value)}
            fullWidth
            sx={{ mb: 2, mt: 1 }}
            autoFocus
          />
          <TextField
            label="Expiry Date"
            type="date"
            value={expiryDate}
            onChange={e => setExpiryDate(e.target.value)}
            fullWidth
            sx={{ mt: 2 }}
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, p: 2 }}>
          <Button onClick={() => setBatchDialogOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleBatchEditSave}
            disabled={!batchNumber || !expiryDate}
          >
            Save
          </Button>
        </Box>
      </Dialog>

      {/* Error Snackbar */}
      <Snackbar
        open={showError}
        autoHideDuration={10000}
        onClose={() => setShowError(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // <-- right top
      >
        <MuiAlert onClose={() => setShowError(false)} severity="error" sx={{ width: '100%' }}>
          Please enter comments before rejecting.
        </MuiAlert>
      </Snackbar>
      <AnnotateAssetActionModal />
    </Grid>
  );
}